import { Box, Dialog, DialogActions, DialogTitle,  IconButton,  List, ListItem, ListItemButton,  ListItemText,  Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import ReactPlayer from 'react-player'
import { blobSAS } from '../Helper/BlobHelper'
import CallSplitIcon from '@mui/icons-material/CallSplit';
import VideoVersionList from './VideoVersionList'
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CloseIcon from '@mui/icons-material/Close';


const VideoList = (props) => {
    const [url, setUrl] = useState(null);
    const [videoDialog, setVideoDialog] = useState(false);
    const [version, setVersion] = useState(null);
    const [versionListsDialog, setVersionListsDialog] = useState(false);
    const playerRef = useRef(null);
    const [sasToken, setSasToken] = useState(null);

    const handleVideoDialog = () => {
        setVideoDialog(false);
    };

    const handleVersionListDialog = () => {
        setVersionListsDialog(false);
    };

    const handleReady = () => {
        if (playerRef.current && playerRef.current.getInternalPlayer()) {
            playerRef.current.getInternalPlayer().requestPictureInPicture().catch(error => {
                console.error("Failed to request Picture-in-Picture:", error);
            });
        }
    };

    useEffect(() => {
        let isMounted = true;

        const loadSasToken = async () => {
            const tokenData = await blobSAS({ token_type: 'read_only', container_name: 'project-executables' });
            if (isMounted) {
                setSasToken(tokenData);
            }
        };

        loadSasToken();

        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <div>
            <div>
                <List dense={true}>
                    {props.videos.map((data, index) => {
                        return (
                            <ListItemButton key={data.id || index} onClick={() => { setVideoDialog(true); setUrl(data.asset_source); }}>
                                <ListItem
                                    secondaryAction={
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    px: 1.25,
                                                    py: 0.4,
                                                    borderRadius: 1,
                                                    color: 'primary.dark',
                                                    backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                                    border: '1px solid rgba(25, 118, 210, 0.18)',
                                                    fontWeight: 600,
                                                    lineHeight: 1.4,
                                                }}
                                            >
                                                Latest: {data.asset_version_name}
                                            </Typography>
                                            <IconButton edge="end" aria-label="delete" onClick={(e) => { e.stopPropagation(); setVersion(data); setVersionListsDialog(true); }}>
                                                <CallSplitIcon />
                                            </IconButton>
                                        </Box>
                                    }
                                >
                                    <ListItemText
                                        primary={data.name}
                                        secondary={data.description ? data.description : null}
                                    />
                                </ListItem>
                            </ListItemButton>
                        );
                    })}
                </List>
            </div>
            <Dialog fullWidth={true} maxWidth="md" open={videoDialog} onClose={handleVideoDialog}>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Box sx={{ m: 2 }}>
                        <ReactPlayer
                            url={sasToken ? sasToken.fd_account_url + url + "?" + sasToken.read_only?.['project-executables'].sas_token : ''}
                            controls={true} pip={true} stopOnUnmount={false}
                            onReady={handleReady}
                            width="500" height="500"
                            playing
                            playIcon={<IconButton><PlayArrowIcon color="primary" sx={{ fontSize: 120 }} /></IconButton>}
                            config={{
                                file: {
                                    attributes: {
                                        controlsList: 'nodownload',
                                        onContextMenu: e => e.preventDefault()
                                    }
                                }
                            }}
                        />
                    </Box>
                </Box>
            </Dialog>
            <Dialog fullWidth={true} maxWidth="md" open={versionListsDialog} onClose={handleVersionListDialog}>
                <DialogTitle sx={{ m: 0, p: 2 }}>
                    <Box sx={{display:'flex'}}>
                    <Box sx={{flexGrow:1}}><Typography variant="h6">Versions</Typography></Box>
                    <Box>
                    <IconButton
                        aria-label="close"
                        onClick={handleVersionListDialog}
                    >
                        <CloseIcon />
                    </IconButton>
                    </Box>
                    </Box>
                </DialogTitle>
                <VideoVersionList data={version} />
                <DialogActions>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default VideoList